import React from 'react'
import ReactDOM from 'react-dom/client'
import { ClerkProvider } from '@clerk/clerk-react'
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { ErrorBoundary } from './ui/components'
import { initSentry } from './sentry'
import './ui/styles.css'
import './ui/landing/landing.css'

// Initialize Sentry error monitoring (Phase 12c)
initSentry()

// Clerk publishable key from environment
const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!CLERK_PUBLISHABLE_KEY) {
  console.warn('Missing VITE_CLERK_PUBLISHABLE_KEY - auth features will be disabled')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      {CLERK_PUBLISHABLE_KEY ? (
        <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
          <RouterProvider router={router} />
        </ClerkProvider>
      ) : (
        <RouterProvider router={router} />
      )}
    </ErrorBoundary>
  </React.StrictMode>
)
